import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center h-screen w-screen bg-accent text-center" }
const _hoisted_2 = { class: "w-fit flex-grow" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "font-extrabold text-3xl pt-2" }, "Pair resource", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", { class: "font-semibold text-base" }, "Enter the resource PIN", -1)
const _hoisted_5 = { class: "pt-4 grid grid-cols-3 gap-4" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]

import TopBar from "@/components/TopBar.vue";
import KeyButton from "@/components/keyboard/KeyButton.vue";
import { computed, onBeforeMount, onMounted, ref } from "vue";
import { useProfileStore } from "@/store/Profile";
import { useRouter, useRoute } from "vue-router";
import { homePath } from "@/router/paths";
import loggingService from "@/services/LoggingService";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const VIBRATION_TIME = 100;

const profileStore = useProfileStore();
const router = useRouter();
const route = useRoute();

const loading = ref(false);
const hasError = ref(false);
const isFilled = (index: number) => {
  return index < pinCode.value.length;
};

const pinCode = ref<number[]>([]);
const pinLength = 6;
const addNumber = async (key: number) => {
  pinCode.value.push(key);

  if (pinCode.value.length === pinLength) {
    loading.value = true;
    const { error } = await profileStore.pairDevice(pinCode.value);
    if (error) {
      hasError.value = true;
      pinCode.value = [];
      loading.value = false;
      hasError.value = true;
      setTimeout(() => {
        hasError.value = false;
      }, 1000);
      try {
        window.navigator.vibrate(VIBRATION_TIME);
      } catch (error) {
        console.log("Vibration is not supported");
      }
    } else {
      loggingService.debug("ProfileStore.ts", `🛣️ Changing route to ${homePath}`);
      await router.push({ name: "Home" });
    }
  }
};

const animClass = computed(() => {
  return {
    anim: hasError.value,
  };
});

const onKeyPressed = (key: string) => {
  if (loading.value) {
    return;
  }
  const numbers = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
  if (numbers.includes(key)) {
    addNumber(+key);
  } else if (key === "Backspace") {
    pinCode.value.pop();
  } else if (key === "deleteAll") {
    pinCode.value = [];
  }
  try {
    window.navigator.vibrate(VIBRATION_TIME);
  } catch (error) {
    console.log("Vibration is not supported");
  }
};

onBeforeMount(() => {
  const pin = route.query.pin;
  if (pin != null) {
    Array.from(pin).forEach(e => {
      if (e != null) {
        addNumber(+e);
      }
    });
  }
});

onMounted(() => {
  window.addEventListener("keydown", e => {
    onKeyPressed(e.key);
  });
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopBar, { "is-connected": "" }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", {
        class: _normalizeClass(["pt-4", _unref(animClass)])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from(Array(pinLength).keys()), (key) => {
          return (_openBlock(), _createElementBlock("span", {
            class: _normalizeClass(["bg-white h-4 w-4 inline-block rounded-full", { 'opacity-30': !isFilled(key), 'ml-2': key !== 0 }]),
            key: key
          }, null, 2))
        }), 128))
      ], 2),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from(Array(9).keys()), (key) => {
          return (_openBlock(), _createBlock(KeyButton, {
            key: key,
            number: key + 1,
            disabled: loading.value,
            onNumericKeyPressed: onKeyPressed
          }, null, 8, ["number", "disabled"]))
        }), 128)),
        _createElementVNode("button", {
          class: "rounded-full border-3 border-opacity-30 border-white text-2xl w-key h-key flex justify-center items-center bg-white bg-opacity-10",
          disabled: loading.value,
          role: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onKeyPressed('deleteAll')))
        }, [
          _createVNode(_component_FontAwesomeIcon, { icon: "times" })
        ], 8, _hoisted_6),
        _createVNode(KeyButton, {
          number: "0",
          disabled: loading.value,
          onNumericKeyPressed: onKeyPressed
        }, null, 8, ["disabled"]),
        _createElementVNode("button", {
          class: "rounded-full border-3 border-opacity-30 border-white text-2xl w-key h-key flex justify-center bg-white bg-opacity-10 items-center",
          disabled: loading.value,
          role: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onKeyPressed('Backspace')))
        }, [
          _createVNode(_component_FontAwesomeIcon, {
            icon: "backspace",
            class: "mr-1"
          })
        ], 8, _hoisted_7)
      ])
    ])
  ]))
}
}

})